import React, { useState, useEffect, useCallback } from "react";
import { getInsightCacheInfo, clearInsightCache } from "../services/api";
import { Button, Card } from "./common/ui";
import RedZoneConfirm from "./common/RedZoneConfirm";

// 2026-10-27 (owner): admin switch to forget every computed Insight / weekly-trend result so each is recomputed fresh when next opened.
// Only the computed cache (cp_weekly_cache) is deleted; decisions, history and settings are untouched. The server writes the audit row.
const fmtDt = (v) => (v ? new Date(v).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export default function InsightCacheCard({ showToast }) {
  const [info, setInfo] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const toast = useCallback((m, t) => { if (showToast) showToast(m, t); }, [showToast]);
  const load = useCallback(() => {
    getInsightCacheInfo().then(setInfo).catch((e) => toast(e.response?.data?.detail || "Could not read the insight cache", "error"));
  }, [toast]);
  useEffect(() => { load(); }, [load]);
  const run = async () => {
    setBusy(true);
    try {
      const r = await clearInsightCache();
      toast(`Cleared ${r.deleted} cached insight${r.deleted === 1 ? "" : "s"}. Each is recomputed when next opened.`, "success");
      setConfirm(false);
      load();
    } catch (e) { toast(e.response?.data?.detail || "Could not clear the insight cache", "error"); }
    finally { setBusy(false); }
  };
  return (
    <Card title="Red zone: cached insights" style={{ border: "1px solid var(--danger)", marginTop: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap", fontSize: 13 }}>
        <span data-testid="insight-cache-info">
          {info ? <><b>{info.count}</b> cached · oldest {fmtDt(info.oldest_cached_at)}</> : "Loading…"}
          {info && info.last_cleared ? <span style={{ color: "var(--text-muted)" }}> · last cleared {fmtDt(info.last_cleared.at)} by {info.last_cleared.by}</span> : null}
        </span>
        <Button variant="danger" disabled={!info || busy} onClick={() => setConfirm(true)}>Clear cached insights</Button>
      </div>
      {confirm && (
        <RedZoneConfirm title="Clear cached insights" word="clear" confirmLabel="Clear all" busy={busy} onCancel={() => setConfirm(false)} onConfirm={run}>
          Deletes all {info ? info.count : ""} stored Insight and weekly-trend results. They are recomputed from Ginesys when next opened (slower first time). Decisions, history and settings are not touched.
        </RedZoneConfirm>
      )}
    </Card>
  );
}
